import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Company } from "../company";
import { Customer } from "../customer";
import type { CompanyBillingProduct } from "./company-product.model";


@CwtModel({ name: 'customer-nego-price' })
@CwtCrudContract({ path: 'company/:companyId/customer-nego-price' })
export class CustomerNegoPrice extends CwtApiEntity {
    @CwtProp({ ref: Company }) company: Company;
    @CwtProp({ ref: Customer }) customer: Customer;
    @CwtProp({ ref: 'company-billing-product' }) companyProduct: CompanyBillingProduct;
    @CwtProp() unitPrice: number;
}